require('./app');

/*!
 * Главная страница
 */
(($) => {
	"use strict";

    $('.section-slider').slick({
        infinite: true,
        slidesToShow: 6,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-participant').slick({
        infinite: true,
        slidesToShow: 6,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-commission').slick({
        infinite: true,
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 1110,
                settings: {
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 820,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-commission_project').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1110,
                settings: {
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 820,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-doc').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-instruction').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-press').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-review').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-event').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: '<button class="slider-prev" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.85808 0L13 10.5L1.85808 21L0 19.2502L9.28646 10.5L0 1.74979L1.85808 0Z"/></svg></button>',
        nextArrow: '<button class="slider-next" type="button"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">n' +
            '<path d="M11.1419 21L0 10.5L11.1419 0L13 1.74979L3.71354 10.5L13 19.2502L11.1419 21Z"/></svg></button>',
    });

    $('.section-slider-face').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    });


    /* search */

    $('.header__btn').on('click', function() {
        $('.search__wrap').addClass('active');
    });

    $('section').on('click', function() {
        $('.search__wrap').removeClass('active');
    });
})($);
